import { SatelliteSharp } from '@mui/icons-material';
import { helpers } from '../../common/lib';
import getInitialState from '../get-initial-state';
import { actionTypes } from './actions';


const initialState = {
    loading: false,
    data: [],
    branchList: [],
    error: '',
}

// If using asset endpoint you could call both at once 

export default function(state=initialState, action){
   
    switch (action.type){

        case actionTypes.DASHBOARD_ASSETS_PER_BRANCH_REQUEST: {
            return {
                ...state,
                loading : true,
                data: [],
                error: '',
                branchList: state.branchList,
                exclusionList: state.exclusionList,
                stockdata: state.stockdata
                
            }
        }
        case actionTypes.DASHBOARD_ASSETS_PER_BRANCH_SUCCESS: {
            
            return {
                ...state,
                loading : false,
                data: action.payload,
                error: '',
                branchList: state.branchList,
                exclusionList: state.exclusionList,
                stockdata: state.stockdata
            }

            
        }
        case actionTypes.DASHBOARD_ASSETS_PER_BRANCH_FAILURE: {
            return {
                loading : false,
                data: [],
                error: action.payload,
                branchList: state.branchList,
                exclusionList: state.exclusionList,
                stockdata: state.stockdata
            }
        }
        case actionTypes.BRANCH_LIST_REQUEST : {
            return {
                ...state,
                loading : true,
                data: {...state},
                error: '',
                branchList: state.branchList,
                exclusionList: state.exclusionList,
                stockdata: state.stockdata
            }
        }
        case actionTypes.BRANCH_LIST_SUCCESS: {
       
            return {
                ...state,
                loading : false,
                data: state.data,
                branchList: action.payload,
                error: '',
                exclusionList: state.exclusionList,
                stockdata: state.stockdata
            }

            
        }
        case actionTypes.BRANCH_LIST_FAILURE: {
           
            return {
                loading : false,
                data: state.data,
                branchList: [],
                error: action.payload,
                exclusionList: state.exclusionList,
                stockdata: state.stockdata
            }
        }
        case actionTypes.EXCLUSION_REASON_REQUEST : {
            return {
                
                loading : true,
                data: state.data,
                error: '',
                branchList: state.branchList,
                exclusionList: [],
                stockdata: state.stockdata
            }
        }
        case actionTypes.EXCLUSION_REASON_SUCCESS: {
    
            return {
                
                loading : false,
                data: state.data,
                branchList: state.branchList,
                exclusionList: action.payload,
                error: '',
                stockdata: state.stockdata
            }

            
        }
        case actionTypes.EXCLUSION_REASON_FAILURE: {
            return {
                loading : false,
                data: state.data,
                branchList: state.branchList,
                error: action.payload,
                exclusionList: [],
                stockdata: state.stockdata
            }
        }
        case actionTypes. STOCK_DATA_REQUEST : {
            return {
                
                loading : true,
                data: state.data,
                error: '',
                branchList: state.branchList,
                exclusionList: state.exclusionList,
                stockdata: [],
            }
        }
        case actionTypes. STOCK_DATA_SUCCESS: {
            
            return {
                
                loading : false,
                data: state.data,
                branchList: state.branchList,
                exclusionList: state.exclusionList,
                error: '',
                stockdata: action.payload
            }

            
        }
        case actionTypes. STOCK_DATA_FAILURE: {
           
            return {
                loading : false,
                data: state.data,
                branchList: state.branchList,
                error: action.payload,
                exclusionList: state.exclusionList,
                stockdata : []
            }
        }
        default: 
            return state;
    }
}
